import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EaGroupComponent } from './ea-group.component';
import { EaGroupsComponent } from './ea-groups/ea-groups.component';
import { ComponentsModule } from '@app/components/components.module';

@NgModule({
  declarations: [EaGroupComponent, EaGroupsComponent],
  exports: [EaGroupComponent, EaGroupsComponent],
  imports: [CommonModule, ComponentsModule],
})
export class EaGroupModule {}
